/**
 * Shared Tailwind class lists for the notifications module's tab strips.
 *
 * Three strips render across the admin surface — page tabs
 * (`notifications/index.tsx`), inbox subcategory tabs (`list/tabs.tsx`),
 * and the popover tray (`shared/notifications/NotificationTray.tsx`).
 * They share the same active-state treatment but the tray uses a tighter
 * trigger to fit within the 380px popover. Defining both variants here
 * keeps the active-state classes from drifting between files.
 */

// Shared TabsList background: gray-100 pill with 1px inset padding.
export const TAB_LIST_CLASSES = 'bg-muted p-1';

// Full-size triggers — used by the page tabs and the admin-list inbox tabs.
// `flex-none` lets the trigger hug its content (icon + label + optional chip)
// rather than stretch across the strip.
export const TAB_TRIGGER_CLASSES =
  'data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm ' +
  'flex-none cursor-pointer gap-2 rounded-md px-3 text-sm text-muted-foreground hover:bg-card/60 hover:text-foreground';

// Compact triggers — used by the tray where horizontal space is bounded
// to ~348px (380px tray − 32px container padding). Same active-state
// classes; tighter typography + spacing + flex-1 split so 3 tabs share
// the row without overflow.
export const TAB_TRIGGER_CLASSES_COMPACT =
  'data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm ' +
  'flex-1 cursor-pointer gap-1.5 rounded-md px-2 text-xs text-muted-foreground hover:bg-card/60 hover:text-foreground';
